import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    "data-page-header": ""
};
import ParentPageHeader from '@molecules/page-headers/ParentPageHeader.vue';
import ChildPageHeader from '@molecules/page-headers/ChildPageHeader.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PageHeader',
    props: {
        title: {},
        subtitle: {},
        postType: {},
        image: {},
        japaneseTranslation: {},
        contentAuthor: {},
        breadcrumbs: {},
        backgroundColor: {},
        termDescription: {},
        totalSearchResults: {},
        is404: { type: Boolean },
        isExhibition: { type: Boolean },
        videoEmbed: {},
        mobileVideoEmbed: {},
        videoFile: {},
        mobileVideoFile: {},
        searchTerm: {},
        useJapaneseFont: { type: Boolean },
        displayHeader: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.displayHeader)
                ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
                    (__props.breadcrumbs)
                        ? (_openBlock(), _createBlock(ChildPageHeader, {
                            key: 0,
                            backgroundColor: __props.backgroundColor,
                            breadcrumbs: __props.breadcrumbs,
                            contentAuthor: __props.contentAuthor,
                            image: __props.image,
                            japaneseTranslation: __props.japaneseTranslation,
                            title: __props.title,
                            subtitle: __props.subtitle,
                            termDescription: __props.termDescription,
                            isExhibition: __props.isExhibition,
                            videoFile: __props.videoFile,
                            mobileVideoFile: __props.mobileVideoFile,
                            videoEmbed: __props.videoEmbed,
                            mobileVideoEmbed: __props.mobileVideoEmbed,
                            useJapaneseFont: __props.useJapaneseFont
                        }, null, 8, ["backgroundColor", "breadcrumbs", "contentAuthor", "image", "japaneseTranslation", "title", "subtitle", "termDescription", "isExhibition", "videoFile", "mobileVideoFile", "videoEmbed", "mobileVideoEmbed", "useJapaneseFont"]))
                        : (_openBlock(), _createBlock(ParentPageHeader, {
                            key: 1,
                            backgroundColor: __props.backgroundColor,
                            breadcrumbs: __props.breadcrumbs,
                            contentAuthor: __props.contentAuthor,
                            image: __props.image,
                            japaneseTranslation: __props.japaneseTranslation,
                            title: __props.title,
                            totalSearchResults: __props.totalSearchResults,
                            searchTerm: __props.searchTerm,
                            useJapaneseFont: __props.useJapaneseFont
                        }, null, 8, ["backgroundColor", "breadcrumbs", "contentAuthor", "image", "japaneseTranslation", "title", "totalSearchResults", "searchTerm", "useJapaneseFont"]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
